import redirectClient, { REDIRECT_PUBLIC_URL } from './redirectClient';
import type {
    RedirectGroup,
    RedirectGroupCreate,
    RedirectGroupUpdate,
    RedirectGroupItem,
    RedirectGroupItemCreate,
    RedirectGroupItemUpdate,
    SyncLog,
    SyncResult,
} from '@/types/redirect-group';

// ========== GROUPS ==========

export const getRedirectGroups = async (onlyActive = false): Promise<RedirectGroup[]> => {
    const response = await redirectClient.get<RedirectGroup[]>('/redirect-groups', {
        params: { only_active: onlyActive },
    });
    return response.data;
};

export const getRedirectGroup = async (groupId: number): Promise<RedirectGroup> => {
    const response = await redirectClient.get<RedirectGroup>(`/redirect-groups/${groupId}`);
    return response.data;
};

export const createRedirectGroup = async (data: RedirectGroupCreate): Promise<RedirectGroup> => {
    const response = await redirectClient.post<RedirectGroup>('/redirect-groups', data);
    return response.data;
};

export const updateRedirectGroup = async (
    groupId: number,
    data: RedirectGroupUpdate
): Promise<RedirectGroup> => {
    const response = await redirectClient.put<RedirectGroup>(`/redirect-groups/${groupId}`, data);
    return response.data;
};

export const deleteRedirectGroup = async (groupId: number): Promise<void> => {
    await redirectClient.delete(`/redirect-groups/${groupId}`);
};

// ========== ITEMS ==========

export const addRedirectGroupItem = async (
    groupId: number,
    data: RedirectGroupItemCreate
): Promise<RedirectGroupItem> => {
    const response = await redirectClient.post<RedirectGroupItem>(
        `/redirect-groups/${groupId}/items`,
        data
    );
    return response.data;
};

export const updateRedirectGroupItem = async (
    itemId: number,
    data: RedirectGroupItemUpdate
): Promise<RedirectGroupItem> => {
    const response = await redirectClient.put<RedirectGroupItem>(
        `/redirect-groups/items/${itemId}`,
        data
    );
    return response.data;
};

export const deleteRedirectGroupItem = async (itemId: number): Promise<void> => {
    await redirectClient.delete(`/redirect-groups/items/${itemId}`);
};

// ========== SYNC ==========

export const syncRedirectGroup = async (groupId: number, background = false): Promise<SyncResult> => {
    const response = await redirectClient.post<SyncResult>(`/sync/group/${groupId}`, null, {
        params: { background },
    });
    return response.data;
};

export const syncAllRedirectGroups = async (background = false): Promise<any> => {
    const response = await redirectClient.post('/sync/all', null, {
        params: { background },
    });
    return response.data;
};

export const getSyncJobs = async (): Promise<any> => {
    const response = await redirectClient.get('/sync/jobs');
    return response.data;
};

export const getSyncLogs = async (groupId: number, limit = 50): Promise<SyncLog[]> => {
    const response = await redirectClient.get<SyncLog[]>(
        `/redirect-groups/${groupId}/sync-logs`,
        { params: { limit } }
    );
    return response.data;
};

// ========== HELPERS ==========

export const buildPublicRedirectUrl = (hashRedirect: string): string => {
    return `${REDIRECT_PUBLIC_URL}/r/${hashRedirect}`;
};

/**
 * URL com placeholder de lingua. O backend aceita qualquer codigo de
 * lingua valido (en, es, pt, fr, de, etc.) ou pt-BR, en-US, etc.
 */
export const buildPublicRedirectUrlWithLang = (
    hashRedirect: string,
    lang: string = '{lang}'
): string => {
    return `${REDIRECT_PUBLIC_URL}/${lang}/r/${hashRedirect}`;
};
